import axios from 'axios';

// Using global axios.defaults.baseURL set in index.jsx

class FooterService {
    static async getFooterStructure(page) {
        try {
            const response = await axios.get(`/front/footer/structure/${page}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching footer structure:', error);
            throw error;
        }
    }

    static async getFooterSection(slug) {
        try {
            const response = await axios.get(`/front/footer/section/${slug}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching footer section:', error);
            throw error;
        }
    }

    static async subscribeNewsletter(email) {
        const response = await axios.post('/front/newsletter/subscribe', { email });
        return response.data;
    }
}

export default FooterService;
